"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Успешный запрос после нажатия на кнопку Зарегистрироваться в форме регистрации или после нажатия Продолжить в модалке Tinkoff id с логином */
const employerRegistrationHr2SuccessExternal = () => analytics_js_1.default.sendEvent("", "registration", "hr2");
exports.default = employerRegistrationHr2SuccessExternal;
